export default __webpack_public_path__ + "static/media/maintenance-result.5f32d8ca.svg";